// Typed callable wrapper with normalized errors. Server errors carry a
// machine-readable `details.code` (OVERTIME_CONFIRMATION_REQUIRED,
// DOUBLE_BOOKED, CREDENTIAL_GAP, SOFT_CONFLICT, PENDING_REQUEST,
// STALE_VERSION, CONFLICT_RESOLUTIONS_REQUIRED, TARGET_NOT_EMPTY) that UI
// flows branch on.
import { httpsCallable } from 'firebase/functions'
import { functions } from '../firebase'

export class CallableError extends Error {
  readonly code: string
  readonly serverCode: string | null
  readonly details: Record<string, unknown>

  constructor(code: string, message: string, details: unknown) {
    super(message)
    this.code = code
    this.details = (details ?? {}) as Record<string, unknown>
    this.serverCode = typeof this.details.code === 'string' ? this.details.code : null
  }
}

export async function call<TResult>(name: string, data: unknown): Promise<TResult> {
  try {
    const fn = httpsCallable(functions, name)
    const res = await fn(data)
    return res.data as TResult
  } catch (e) {
    const err = e as { code?: string; message?: string; details?: unknown }
    throw new CallableError(err.code ?? 'unknown', err.message ?? 'Something went wrong.', err.details)
  }
}
